import { useId } from 'react';
import ContentLoader from 'react-content-loader';

import { DeviceSwitcher } from '../../components/device-switcher.component';
import { FindyLogoLink } from '../../components/findy-logo-link.component';
import styles from './header-skeleton.component.module.scss';

const DesktopHeaderSkeleton = () => {
  const id1 = useId();
  const id2 = useId();

  return (
    <div className={styles.desktopWrapper}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <FindyLogoLink />
        <ContentLoader
          height={52}
          uniqueKey={id1}
          viewBox="0 0 450 52"
          width={450}
        >
          <rect height="20" rx="3" ry="3" width="90" x="0" y="16" />
          <rect height="20" rx="3" ry="3" width="90" x="120" y="16" />
          <rect height="20" rx="3" ry="3" width="90" x="240" y="16" />
          <rect height="20" rx="3" ry="3" width="90" x="360" y="16" />
        </ContentLoader>
      </div>
      <ContentLoader
        height={52}
        uniqueKey={id2}
        viewBox="0 0 330 52"
        width={330}
      >
        <rect height="20" rx="3" ry="3" width="90" x="0" y="16" />
        <rect height="20" rx="3" ry="3" width="90" x="120" y="16" />
        <rect height="20" rx="3" ry="3" width="90" x="240" y="16" />
      </ContentLoader>
    </div>
  );
};

const IconSize = 36;
// MEMO:
// 高さに対するFindyロゴの配置位置が左右のパーツの大きさに依存する作りになっている
const MobileHeaderSkeleton = () => {
  const id1 = useId();
  const id2 = useId();

  return (
    <div className={styles.mobileWrapper}>
      <ContentLoader
        height={IconSize}
        uniqueKey={id1}
        viewBox={`0 0 ${IconSize} ${IconSize}`}
        width={IconSize}
      >
        <rect height={IconSize} rx="5" ry="5" width={IconSize} x="0" y="0" />
      </ContentLoader>
      <FindyLogoLink align="center" />
      <ContentLoader
        height={IconSize}
        uniqueKey={id2}
        viewBox={`0 0 ${IconSize} ${IconSize}`}
        width={IconSize}
      >
        <rect height={IconSize} rx="5" ry="5" width={IconSize} x="0" y="0" />
      </ContentLoader>
    </div>
  );
};

export const HeaderSkeleton = () => {
  return (
    <DeviceSwitcher
      desktop={<DesktopHeaderSkeleton />}
      mobile={<MobileHeaderSkeleton />}
    />
  );
};
